import FileUploadApi from "../services/api/FileUpload";
import Errors from "../constants/Errors.json";

export const getPreSignedUrls = async (payload, uploadUrl) => {
  const result = await FileUploadApi.fileUpload(uploadUrl, payload);
  if (result) {
    return [result.callback_key, result.upload_url];
  } else {
    throw new Error(Errors.FILE_UPLOAD_FAILED);
  }
};

export const FileUploadS3 = async (
  key,
  url,
  file,
  uploadUrl,
  keyName,
  noAckCall,
  extraParamsAckObj
) => {
  const uploadedS3Url = await FileUploadApi.uploadToS3(url, file);
  if (noAckCall !== undefined) {
    return true;
  } else {
    const res = await FileUploadApi.uploadFileSuccess(uploadUrl, {
      [keyName]: key,
      ...extraParamsAckObj,
    });
    if (res) {
      return uploadedS3Url;
    } else {
      throw new Error(Errors.FILE_UPLOAD_FAILED);
    }
  }
};

export const MultiFileUploadS3 = async (
  key,
  urls,
  files,
  uploadUrl,
  keyName,
  noAckCall,
  extraParamsAckObj
) => {
  const uploadedFiles = [];
  for (let i = 0; i < files.length; i++) {
    const url = urls[files[i].name];
    if (url == undefined) {
      throw new Error(Errors.FILE_UPLOAD_FAILED);
    }
    uploadedFiles.push(FileUploadApi.uploadToS3(url, files[i]));
  }
  const allUploded = await Promise.all(uploadedFiles);
  if (noAckCall !== undefined) {
    return true;
  } else {
    const res = await FileUploadApi.uploadFileSuccess(uploadUrl, {
      [keyName]: key,
      ...extraParamsAckObj,
    });
    if (res) {
      return allUploded;
    } else {
      throw new Error(Errors.FILE_UPLOAD_FAILED);
    }
  }
};
